import type React from 'react'

import { ShowResolvedCtx } from './context'
import { useShowResolvedState } from './hooks'

export const ShowResolvedContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const state = useShowResolvedState()

  return (
    <ShowResolvedCtx.Provider value={state}>
      {children}
    </ShowResolvedCtx.Provider>
  )
}
